<template>
  <div>
    <h3 class="mb-3">Просмотр заявки</h3>
    <div v-if="request">
      <div class="mb-3">
        <h2 class="mb-2">Флорист</h2>
        <va-input :value="getFloristName(request.florist_id)" disabled />
      </div>
      <div class="mb-3">
        <h2 class="mb-2">Имя</h2>
        <va-input :value="request.name" disabled />
      </div>
      <div class="mb-3">
        <h2 class="mb-2">Телефон</h2>
        <va-input :value="request.phone" disabled />
      </div>
      <div class="mb-3">
        <h2 class="mb-2">Email</h2>
        <va-input :value="request.email || '-'" disabled />
      </div>
      <div class="mb-3">
        <h2 class="mb-2">Текст заявки</h2>
        <va-input
          :value="request.text || '-'"
          type="textarea"
          :min-rows="4"
          :max-rows="8"
          disabled
        />
      </div>
      <div class="mb-3">
        <h2 class="mb-2">Дата создания</h2>
        <va-input :value="formatDate(request.created_at)" disabled />
      </div>
    </div>
    <div class="mt-3">
      <va-button color="primary" @click.prevent="$emit('close')">
        Закрыть
      </va-button>
    </div>
  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: 'FloristRequestView',
  props: {
    request: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      florists: [],
    };
  },
  async created() {
    await this.loadFlorists();
  },
  methods: {
    async loadFlorists() {
      try {
        const response = await api.get('/admin/florists', { params: { all: 1 } });
        this.florists = response.data.data || [];
      } catch (error) {
        console.error('Ошибка загрузки флористов:', error);
        this.florists = [];
      }
    },
    getFloristName(floristId) {
      const florist = this.florists.find((f) => f.id === floristId);
      return florist ? florist.name : '-';
    },
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      return d.toLocaleString('ru-RU', { timeZone: 'Asia/Omsk' });
    },
  },
};
</script>

<style></style>

